
export const getUserId = () => {
    let dataLocalStorage = JSON.parse(localStorage.getItem('user'));
    let user_id = dataLocalStorage !== '' ? dataLocalStorage?.id : '';
    return user_id;
}

export const getUsername = () => {
    let dataLocalStorage = JSON.parse(localStorage.getItem('user'));
    let username = dataLocalStorage !== '' ? dataLocalStorage?.name : '';
    return username;
}

export const getSearch = () => {
    let dataLocalStorage = localStorage.getItem('search');
    let search = dataLocalStorage;
    return search;
}

export const getCategory = () => {
    let dataLocalStorage = localStorage.getItem('category');
    let search = dataLocalStorage;
    return search;
}

export const getSubcategory = () => {
    let dataLocalStorage = localStorage.getItem('subcategory');
    let search = dataLocalStorage;
    return search;
}

export const getMailDniUserId = () => {
    let dataLocalStorage = JSON.parse(localStorage.getItem('user')) || {}; // Asegura que dataLocalStorage no sea null/undefined
    let mail = dataLocalStorage.mail || '';
    let dni = dataLocalStorage.dni || '';
    let user_id = dataLocalStorage.id || '';
    return { mail, dni, user_id }; // Devuelve un objeto
}